import React, {Component} from 'react';
import Schedule from '../templates/schedule';
import Error from '../../ui_core/message/errors';

class schedulePage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data:    {},
            message: {},
            saveState: {
             pending: false,
             status: ''
            }
        };
        this.changeState = this.changeState.bind(this);
        this.getData = props.tools.getData.bind(this);
        this.setData = props.tools.setData.bind(this);
    }

    componentDidMount() {
        this.getData()
            .then(data => {
                //fill initial parameter for submit
                this.setState({ data });
            });
    }

    changeState(data) {
        this.setState(data)
    }

    render() {
        return (
            <div className="pageBlock">
                {Object.keys(this.state.message).length ? <Error {...this.state.message} /> :  <Schedule {...this}/>}
            </div>
        );
    }
}

export default schedulePage;